const SET_SELECTED = 'storePages/SET_SELECTED';
const SET_PAGES = 'storePages/SET_PAGES';
const ADD_PAGES = 'storePages/ADD_PAGES';

export default {
  SET_SELECTED,
  SET_PAGES,
  ADD_PAGES,
};



// WEBPACK FOOTER //
// ./src/app/store-pages/store/mutation-types.js